import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { SlideSwitch } from '../../../../components/Buttons/SlideSwitch'
import { Button } from '../../../../components/UI'
import VerificationCodeModal from './VerificationCodeModal'

import {
  selectErrorVerifyTwoFactorAuth,
  selectLoadingActivateTwoFactorAuth,
  selectLoadingDeactivateTwoFactorAuth,
  selectLoadingVerifyTwoFactorAuth,
  selectUserData,
} from '../../../../routing/fetchingfunction/user/user.reducer'
import {
  activateTwoFactorAuth,
  deactivateTwoFactorAuth,
  verifyTwoFactorAuth,
} from '../../../../routing/fetchingfunction/user/user.action'

const TwoFactorAuthentication = () => {
  const dispatch = useDispatch()

  const userData = useSelector(selectUserData)
  const isActivateLoading = useSelector(selectLoadingActivateTwoFactorAuth)
  const isDeactivateLoading = useSelector(selectLoadingDeactivateTwoFactorAuth)
  const isVerificationLoading = useSelector(selectLoadingVerifyTwoFactorAuth)
  const verificationRequestError = useSelector(selectErrorVerifyTwoFactorAuth)

  const isActive = userData?.is_two_fa || false

  const [verificationCodeModalData, setVerificationCodeModalData] = useState(null)

  const handleSendSms = () => {
    const phoneNumberPart = userData?.profile?.phone_number_part
    const countryCode = userData?.profile?.country_code

    if (!phoneNumberPart || !countryCode) {
      return
    }

    const phoneNumber = {
      phone_number: userData?.profile?.country_code + userData?.profile?.phone_number_part,
    }

    dispatch(activateTwoFactorAuth(phoneNumber)).then((response) => {
      if (!response.error) {
        setVerificationCodeModalData(phoneNumber)
      }
    })
  }

  const handleActiveChange = () => {
    if (isActive) {
      dispatch(deactivateTwoFactorAuth())
    }
  }

  const handleSubmitVerificationCodeModal = (code) => {
    dispatch(
      verifyTwoFactorAuth({
        ...verificationCodeModalData,
        otp: code,
      })
    ).then((response) => {
      if (!response.error) {
        handleCloseVerificationCodeModal()
      }
    })
  }

  const handleCloseVerificationCodeModal = () => {
    setVerificationCodeModalData(null)
  }

  return (
    <div className="mt-[20px] border-[1px] border-solid border-[#FFCA84] rounded-lg p-[20px]">
      <div className="flex justify-between items-center">
        <h5 className="text-sm font-semibold text-primary-100">Enable Two Factor Authentication</h5>

        <div className="h-100 flex align-items-center justify-content-center text-primary-100">
          Activate{' '}
          <SlideSwitch
            sx={{ m: 1 }}
            checked={isActive}
            onChange={handleActiveChange}
            disabled={isActivateLoading || isDeactivateLoading}
          />
        </div>
      </div>

      <p className="mt-[2px] text-sm text-primary-100">
        Each time you sign in to your account, you’ll need your password and a verification code.
      </p>

      {!isActive && (
        <div className="mt-[10px] border-[1px] border-solid border-[#FFCA84] rounded-[10px] p-[20px]">
          <span className="text-sm font-semibold text-primary-100">Text Message</span>

          <div className="mt-[6px] text-sm text-primary-100">
            You will receive the security codes in this registered phone number.
          </div>

          <div className="mt-[6px] flex flex-col">
            <div className="flex items-center gap-x-[8px]">
              <div className="max-w-[140px] w-full">
                <input
                  type="tel"
                  placeholder="Country Code"
                  className="w-full rounded-[8px] bg-white shadow-button px-[14px] py-[10px] text-[#f67443b3] text-base font-normal leading-[24px] placeholder:text-[#F6744388]"
                  value={userData?.profile?.country_code || ''}
                  readOnly
                  disabled
                />
              </div>

              <input
                type="tel"
                placeholder="Phone Number"
                className="w-[200px] rounded-[8px] bg-white shadow-button px-[14px] py-[10px] text-[#f67443b3] text-base font-normal leading-[24px] placeholder:text-[#F6744388]"
                value={userData?.profile?.phone_number_part || ''}
                readOnly
                disabled
              />

              <Button
                type="button"
                className="!text-sm !font-semibold min-w-[102px]"
                isLoading={isActivateLoading}
                onClick={handleSendSms}
              >
                Send SMS
              </Button>
            </div>
          </div>
        </div>
      )}

      <VerificationCodeModal
        open={!!verificationCodeModalData}
        phoneNumber={verificationCodeModalData?.phone_number}
        requestError={verificationRequestError}
        isLoading={isVerificationLoading}
        onSubmit={handleSubmitVerificationCodeModal}
        onClose={handleCloseVerificationCodeModal}
      />
    </div>
  )
}

export default TwoFactorAuthentication
